<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Apps - Categoria | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
                <option value="9">Excluído</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_aplicativo">Aplicativo <sup class="text-danger">* </sup></label>
              <select id="cd_aplicativo" v-model="registro.cd_aplicativo" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_aplicativo }">
                <option v-for="item in aplicativos" v-bind:value="item.cd_aplicativo">{{ item.descricao }}</option>
              </select>
              <span v-show="errors.cd_aplicativo != null" class="help-inline">{{ errors.cd_aplicativo }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AplicativoActions from '../../actions/AplicativoActions'
import AplicativoCategoriaActions from '../../actions/AplicativoCategoriaActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        descricao: '',
        cd_aplicativo: '',
        idc_status: ''
      },
      aplicativos: []
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    this.listarAplicativoAtivos()

    AplicativoCategoriaActions.obter(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/aplicativo-categorias')
    },
    listarAplicativoAtivos () {
      AplicativoActions.listarAtivos()
        .then(res => {
          this.aplicativos = res
        })
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cd_aplicativo) {
        this.errors.cd_aplicativo = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        AplicativoCategoriaActions.alterar({
          id: this.id,
          descricao: this.registro.descricao,
          cd_aplicativo: this.registro.cd_aplicativo,
          idc_status: this.registro.idc_status
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/aplicativo-categorias')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativo-categorias/Editar.vue